import { APICore } from './apiCore';
import { MediaItem } from 'pages/apps/Ecommerce/hooks/types';

const api = new APICore();
// Poojari interface

interface PoojariDetails {
  name: string;
  phone?: string;
  email?: string;
  profilePicture?: string;
  languages?: string[];
  experience?: number;
  rating?: number;
  isAvailable?: boolean;
  location?: string;
  latitude?: number;
  longitude?: number;
  bio?: string;
  isVerified?: boolean;
  poojasDone?: number;
  poojariMedia?: any[];
  poojariRituals?: any[];
}


// Get all poojaris with pagination
function getPoojaris(params: any) {
    const baseUrl = params.latitude && params.longitude ? '/poojari/filtered' : '/poojari';
    return api.get(`${baseUrl}`, params);
}

// Add a new poojari
function addPoojari(params: PoojariDetails) {
    const baseUrl = '/poojari/createPoojari';
    return api.create(`${baseUrl}`, params);
}

// Get poojari details by ID
function getPoojariDetails(params: { poojariId: string }) {
    const baseUrl = `/poojari/${params?.poojariId}`;
    return api.get(`${baseUrl}`, '');
}

// Update poojari details
function updatePoojariDetails(params: any) {
    // Accept either `poojariId` (used elsewhere) or `id` for compatibility
    const { id, poojariId, ...body } = params;
    const idToUse = id ?? poojariId;
    if (!idToUse) throw new Error('Missing poojari id for update');
    const baseUrl = `/poojari/${idToUse}`;
    return api.updatePatch(`${baseUrl}`, body);
}

// Delete poojari by ID
function deletePoojariByIdApi(poojariId: number) {
    const baseUrl = `/poojari/${poojariId}`;
    return api.delete(baseUrl);
}

export { getPoojaris, addPoojari, getPoojariDetails, updatePoojariDetails, deletePoojariByIdApi };
